'use strict';

import {updateAddToCart} from './addToCart';
import {updateAvailability} from './availabilityUtils';
import {requestProductUpdate} from './variationsUtils';
import {addEventListenerList} from '../helpers/utilities';
import {getSelectedStoreInput} from '../modules/module.store-locator.js';
import {getProductContainer, getQuantitySelector} from './productUtils';
import {deselectStore, requestInventoryCheck, updateTriggerStatus} from '../storePickup/storePickup';

/**
 * Update the product data with the `storeId` value before it's added to cart.
 */
function _setStoreIDOnProductData(productObject, productContainer) {
    let storeIDEl = getSelectedStoreInput(productContainer),
        productOptions = productObject && productObject.options ? JSON.parse(productObject.options) : null;

    productObject.storeId = storeIDEl && storeIDEl.value ? storeIDEl.value : null;

    //Push the selected `storeId` in the product's options array.
    //This is a safe way to handle it since in the backend `cartHelpers.addProductToCart()` method,
    //the `storeId` object is removed from this options array.
    if (productOptions) {
        productOptions.push({
            storeId: productObject.storeId
        });

        productObject.options = JSON.stringify(productOptions);
    }
}

export default {
    updateSelectStore: function() {
        $('body').on('storePickup:afterInventoryCheck', function(evt, response) {
            updateTriggerStatus(response.data, response.container);
            updateAvailability(response.data, response.container);
            updateAddToCart(response.data.product, response.container);
        });
    },

    removeSelectedStoreOnAttributeChange: function() {
        $('body').on('product:afterAttributeSelect', function(evt, response) {
            let storeIDEl = getSelectedStoreInput(response.container);

            updateTriggerStatus(response.data, response.container);

            if (storeIDEl && storeIDEl.value) {
                requestInventoryCheck(response.container, response.data.product.id, storeIDEl.value);
            }
        });
    },

    updateAddToCartFormData: function() {
        $('body').on('product:updateAddToCartFormData', function(e, response) {
            //Special check for when the current product has children products.
            //This should only be the case for Product Sets.
            if (response.formData.pidsObj) {
                let pidsObj = JSON.parse(response.formData.pidsObj);

                pidsObj.forEach(function(currentData, index) {
                    _setStoreIDOnProductData(currentData, response.childProducts.list[index]);
                });

                response.formData.pidsObj = JSON.stringify(pidsObj);
            }

            _setStoreIDOnProductData(response.formData, response.container);
        });
    },

    removeStoreSelection: function() {
        addEventListenerList('[data-product-component="pickup-remove"]', 'click', function() {
            deselectStore(getProductContainer(this));
            requestProductUpdate.call(getQuantitySelector(this));
        });
    }
};
